module.exports = __webpack_public_path__ + "assets/img/dcb@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/dcb@2x.png
// module id = 129
// module chunks = 0